import { STATIC_ASSETS_PLACEHOLDER } from "../staticAssetsPlaceholder.js";
export const vintageSymmetry = {
    version: 1,
    themeId: "vintage-symmetry",
    name: "Vintage Symmetry",
    endFadeDuration: 1,
    thumbnailFrame: 100,
    thumbnailUrl: `${STATIC_ASSETS_PLACEHOLDER}/compilations/theme-stills/vintage-symmetry.webp`,
    background: [
        {
            variant: "diamonds",
            urls: [
                `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/vintage-symmetry/pattern1.png`,
                `${STATIC_ASSETS_PLACEHOLDER}/compilations/themes/vintage-symmetry/pattern2.png`,
            ],
            blendMode: "opacity",
            backgroundColor: "#000",
            style: {
                backgroundSize: "250px",
                opacity: 0.4,
            },
        },
    ],
    scenes: [
        {
            type: "generalSolidIntro",
            durationSeconds: 6,
            transitionVariant: "symmetry-box",
            faceCollage: {
                variant: "top-bottom-static",
                borderShape: "diamond",
                startAtSeconds: 1,
                entrance: {
                    variant: "diamond-mask",
                    transitionDurationInFrames: 10,
                    exitDurationInFrames: 10,
                },
            },
            title: {
                fontFamily: "FrankRuhlLibre",
                fontSize: 170,
                fontWeight: "extralight",
                letterSpacing: "widest",
            },
            exitTransition: {
                variant: "centerWipe",
                direction: "vertical",
                disableExitFade: true,
                timing: {
                    variant: "linear",
                    durationSeconds: 1,
                },
            },
        },
        {
            type: "greeting",
            variant: "intro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
            betweenMessageTransition: {
                variant: "scale",
                enterDurationSeconds: 0.33333,
                exitDurationSeconds: 0.16666,
            },
        },
        {
            type: "clip-series-basic",
            showLogo: true,
        },
        {
            type: "greetingLinesAsScenes",
            variant: "outro",
            secondsPerCharacter: 0.1,
            minimumMessageDisplayTimeSeconds: 3,
        },
        {
            type: "outro",
            colorVariant: "lightBlue",
        },
    ],
    styles: {
        textBox: {
            backgroundColor: "#fff",
            backgroundOpacity: 0,
            backgroundBlur: 2,
            textAlign: "center",
            textColor: "#fff",
            fontFamily: "FrankRuhlLibre",
            fontWeight: "light",
            fontSize: 80,
            leading: 1.1,
            tracking: 0.1,
            containerCustom: {
                background: `linear-gradient(to bottom, transparent, rgba(0,0,0,0.7) 50%, transparent)`,
            },
            custom: {
                textTransform: "uppercase",
                textShadow: "0.5rem 0.5rem 0.5rem rgba(0,0,0,0.1)",
            },
        },
        clips: {
            textVariant: {
                variant: "slide-in-static",
                entranceVariant: "slide-to-flush-left",
                startOffsetSeconds: 0.6,
                cards: [
                    {
                        backgroundColor: "#0e0d09",
                        backgroundOpacity: 1,
                    },
                ],
            },
            betweenTransition: {
                variant: "centerWipe",
                direction: "vertical",
                timing: {
                    variant: "linear",
                    durationSeconds: 1,
                },
            },
            title: {
                backgroundColor: "#fff",
                backgroundOpacity: 0.95,
                textColor: "#f1ede8",
                fontFamily: "Oswald",
                fontWeight: "light",
                fontSize: 60,
                nudge: 2,
                textTransform: "none",
            },
            subtitle: {
                backgroundColor: "#3f3f46",
                backgroundOpacity: 0.95,
                textColor: "#f1ede8",
                fontFamily: "Oswald",
                fontWeight: "light",
                fontSize: 40,
                nudge: 2,
                textTransform: "none",
            },
            scaleFactor: 1,
            borderRadius: "0",
            boxShadow: "none",
        },
        watermark: {
            opacity: 0.8,
            margin: 32,
            enterTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
            exitTransition: {
                variant: "marginSlide",
                direction: "from-left",
                timing: { variant: "linear", durationSeconds: 0.5 },
            },
        },
        sceneTransition: {
            variant: "centerWipe",
            direction: "vertical",
            timing: {
                variant: "linear",
                durationSeconds: 1,
            },
        },
    },
    userInputFields: [
        {
            id: "titleMessage",
            type: "text",
            label: "Title Message",
            defaultValue: "",
            placeholder: "Way To Go, Hannah!",
            required: true,
            min: 1,
            max: 50,
            preview: {
                sceneIndex: 0,
                frameOffset: 70,
            },
        },
    ],
    colorPalettes: ["Black"],
};
